import { Box, ButtonBase, Typography } from '@mui/material'
import { Course } from 'src/v3/core/types'
import {
  coursePublicImageSrc,
  onCourseImageError,
} from 'src/v3/self-paced/utils/course-thumbnail'
import {
  ctaRouteFor,
  progressDisplayFor,
} from 'src/v3/self-paced/utils/progress-display'
import { CourseProgressSummary } from 'src/v3/self-paced/types'
import { StatusChip } from './status-chip'

export let ActionItemCard = ({
  progress,
  course,
  onNavigate,
}: {
  progress: CourseProgressSummary
  course: Course | undefined
  onNavigate: (path: string) => void
}) => {
  // Progress entries always point at a real course — a missing lookup means
  // the courses fetch hasn't landed yet, so skip rendering rather than show
  // a broken card. Caller should .filter(Boolean) if it cares.
  if (!course) return null

  let display = progressDisplayFor(progress)
  let target = display.cta
    ? ctaRouteFor(progress, display.cta.kind)
    : `/self-paced/course/${course.id}`

  return (
    <ButtonBase
      onClick={() => onNavigate(target)}
      focusRipple
      sx={{
        display: 'block',
        minWidth: 320,
        textAlign: 'left',
        alignItems: 'stretch',
        borderRadius: 2,
        transition: 'transform 0.3s ease',
        '&:hover': { transform: 'scale(1.02)' },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '16/9',
          overflow: 'hidden',
          borderRadius: 2,
          bgcolor: '#000000',
        }}
      >
        <img
          src={coursePublicImageSrc(course.imageName)}
          onError={(event) => onCourseImageError(event, course.imageName)}
          alt={course.displayName}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <StatusChip label={display.tagLabel} color={display.tagColor} />
      </Box>

      <Typography
        component="p"
        variant="subtitle1"
        noWrap
        sx={{ color: 'white', mt: 1.5, fontWeight: 600 }}
      >
        {course.displayName}
      </Typography>
      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
        {display.subtitle}
      </Typography>
    </ButtonBase>
  )
}
